import { PortfolioEngineAccount } from '@ndvr/portfolio-api';

import { PortfolioInferredPositions } from '@/cip/_openapi/portfolio-optimizer';

import { TLHHolding, TLHReplacement } from './api/tlh-types';

export enum OnboardingWizardStep {
    MANAGEMENT = 'management',
    TARGET_ALLOCATION = 'targetAllocation',
    TAX_LOSS_HARVESTING = 'taxLossHarvesting',
    FINAL_REVIEW = 'finalReview',
}

export const ONBOARDING_WIZARD_STEP_ORDER: OnboardingWizardStep[] = [
    OnboardingWizardStep.MANAGEMENT,
    OnboardingWizardStep.TARGET_ALLOCATION,
    OnboardingWizardStep.TAX_LOSS_HARVESTING,
    OnboardingWizardStep.FINAL_REVIEW,
];

export const ONBOARDING_WIZARD_STEP_LABELS: Record<OnboardingWizardStep, string> = {
    [OnboardingWizardStep.MANAGEMENT]: 'Management',
    [OnboardingWizardStep.TARGET_ALLOCATION]: 'Target Allocation',
    [OnboardingWizardStep.TAX_LOSS_HARVESTING]: 'Tax Loss Harvesting',
    [OnboardingWizardStep.FINAL_REVIEW]: 'Final Review',
};

export interface ManagementSettings {
    taxLossHarvesting: boolean;
    cashEqSweep: boolean;
}

export const INITIAL_MANAGEMENT_SETTINGS: ManagementSettings = {
    taxLossHarvesting: true,
    cashEqSweep: true,
};

export interface TaxLossHarvestingSettings {
    replacementsByHolding: Record<string, TLHReplacement[]>;
}

export const INITIAL_TLH_SETTINGS: TaxLossHarvestingSettings = {
    replacementsByHolding: {},
};

export interface OnboardingWizardState {
    portfolioBoostEnabled: boolean;
    management: ManagementSettings;
    taxLossHarvesting: TaxLossHarvestingSettings;
    // accountGUID → { `${sId}-${scId ?? ''}` → percent string (e.g. "25.50") }
    weightOverrides: Record<string, Record<string, string>>;
}

export const INITIAL_ONBOARDING_WIZARD_STATE: OnboardingWizardState = {
    portfolioBoostEnabled: true,
    management: INITIAL_MANAGEMENT_SETTINGS,
    taxLossHarvesting: INITIAL_TLH_SETTINGS,
    weightOverrides: {},
};

export interface OnboardingStepProps {
    accounts: PortfolioEngineAccount[];
    state: OnboardingWizardState;
    setState: React.Dispatch<React.SetStateAction<OnboardingWizardState>>;
    inferredPositions: PortfolioInferredPositions[];
    isInferredPositionsLoading: boolean;
    tlhHoldings: TLHHolding[];
    isTlhHoldingsLoading: boolean;
}
